import ConfigDrivenContainerLayout from '../components/Layout/ConfigDrivenContainerLayout';
import MFASettings from '../components/Security/MFASettings';

const SecuritySettingsRoute = () => {
  return (
    <ConfigDrivenContainerLayout showOnlyBackButton hideChat>
      <div className='flex flex-row h-[60vh] items-center'>
        <MFASettings />
      </div>
    </ConfigDrivenContainerLayout>
  );
};

export default SecuritySettingsRoute;
